import styled from '@emotion/styled';

export const PlaceholderContent = styled.section`
    padding: 24px;
`;
